module.exports = __webpack_public_path__ + "img/index2.262f845f.png";